const styles = {
  deleteButton: {
    marginRight: 'auto !important'
  },
  text: {
    height: '200px'
  }
}

export default styles
